import { httpClient } from 'utils/httpClient';
import {
  FumDocData, BoletaDocData, ActaDocData,
  ConstanciaDocData, RodDocData, HistorialDocData, NominaDocData,
  CertificadoDocData, BoletaSIAGIEDocData,
} from 'types/documento.types';

export const documentoService = {
  async getFum(matriculaId: number): Promise<FumDocData> {
    return httpClient.get<FumDocData>(`/documentos/fum/${matriculaId}`);
  },
  async getBoleta(matriculaId: number, periodoId: number): Promise<BoletaDocData> {
    return httpClient.get<BoletaDocData>(`/documentos/boleta/${matriculaId}?periodoId=${periodoId}`);
  },

  async getBoletasMasivo(params: {
    anioEscolarId: number;
    gradoId:       number;
    seccionId:     number;
    periodoId:     number;
  }): Promise<BoletaDocData[]> {
    const q = new URLSearchParams({
      gradoId:       String(params.gradoId),
      seccionId:     String(params.seccionId),
      anioEscolarId: String(params.anioEscolarId),
      periodoId:     String(params.periodoId),
    });
    return httpClient.get<BoletaDocData[]>(`/documentos/boletas/seccion?${q}`);
  },
  async getActaConsolidada(params: { gradoId: number; seccionId: number; anioEscolarId: number }): Promise<ActaDocData> {
    const q = new URLSearchParams({
      gradoId: String(params.gradoId),
      seccionId: String(params.seccionId),
      anioEscolarId: String(params.anioEscolarId),
    });
    return httpClient.get<ActaDocData>(`/documentos/acta-consolidada?${q}`);
  },
  async getConstancia(matriculaId: number): Promise<ConstanciaDocData> {
    return httpClient.get<ConstanciaDocData>(`/documentos/constancia/${matriculaId}`);
  },
  async getRod(anioEscolarId: number): Promise<RodDocData> {
    return httpClient.get<RodDocData>(`/documentos/rod?anioEscolarId=${anioEscolarId}`);
  },
  async getHistorial(estudianteId: number): Promise<HistorialDocData> {
    return httpClient.get<HistorialDocData>(`/documentos/historial/${estudianteId}`);
  },
  async getNomina(nominaId: number): Promise<NominaDocData> {
    return httpClient.get<NominaDocData>(`/documentos/nomina/${nominaId}`);
  },

  async getBoletasSIAGIEMasivo(params: {
    anioEscolarId: number;
    gradoId:       number;
    seccionId:     number;
  }): Promise<BoletaSIAGIEDocData[]> {
    const q = new URLSearchParams({
      gradoId:       String(params.gradoId),
      seccionId:     String(params.seccionId),
      anioEscolarId: String(params.anioEscolarId),
    });
    return httpClient.get<BoletaSIAGIEDocData[]>(`/documentos/boletas-siagie/seccion?${q}`);
  },

  /** GET /documentos/certificado/{matriculaId} — certificado individual */
  async getCertificado(matriculaId: number): Promise<CertificadoDocData> {
    return httpClient.get<CertificadoDocData>(`/documentos/certificado/${matriculaId}`);
  },

  /** GET /documentos/certificados/masivo — todos los estudiantes del grado/sección */
  async getCertificadosMasivo(params: {
    anioEscolarId: number;
    gradoId:       number;
    seccionId:     number;
  }): Promise<CertificadoDocData[]> {
    const q = new URLSearchParams({
      anioEscolarId: String(params.anioEscolarId),
      gradoId:       String(params.gradoId),
      seccionId:     String(params.seccionId),
    });
    return httpClient.get<CertificadoDocData[]>(`/documentos/certificados/masivo?${q}`);
  },
};
